/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ExamRevisionLangBotexamlangid202,
  DeleteApiV1ExamRevisionLangBotexamlangid400,
  DeleteApiV1ExamRevisionLangBotexamlangid401,
  DeleteApiV1ExamRevisionLangBotexamlangid404,
  DeleteApiV1ExamRevisionLangBotexamlangid500,
  DeleteApiV1ExamRevisionLangBotexamlangidMutationResponse,
  DeleteApiV1ExamRevisionLangBotexamlangidPathParams,
} from "../../types/examRevisionController/DeleteApiV1ExamRevisionLangBotexamlangid.ts";

export const deleteApiV1ExamRevisionLangBotexamlangidPathParamsSchema =
  z.object({
    botExamLangId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ExamRevisionLangBotexamlangid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ExamRevisionLangBotexamlangid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ExamRevisionLangBotexamlangid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ExamRevisionLangBotexamlangid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ExamRevisionLangBotexamlangid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangid500>;

export const deleteApiV1ExamRevisionLangBotexamlangidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ExamRevisionLangBotexamlangid202Schema,
  ) as unknown as ToZod<DeleteApiV1ExamRevisionLangBotexamlangidMutationResponse>;
